import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import jsSha512 from 'js-sha512';
import { API } from 'api';
import { redirectToLogin } from 'api/authentication';

export function setLocalData(UserData) {
	localStorage.setItem(process.env.REACT_APP_AUTH_KEY, JSON.stringify(UserData));
}

const initialState = {
	me: {},
	selectedSalesMan: {},
};

export const userSlice = createSlice({
	name: 'user', // name of the reducer
	initialState,
	reducers: {
		setUser: (state, { payload = {} }) => {
			state.me = payload;
		},
		setselectedSalesMan: (state, { payload = {} }) => {
			state.selectedSalesMan = payload;
		},
	},
});

export const { setUser, setselectedSalesMan } = userSlice.actions;

export const generateOtp = (values, setErrors) => async () => {
	const CREDENTIALS = {
		url: `/sales-men/generate-otp`,
		method: 'post',
		data: values,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		toaster.success('OTP sent to you');

		return response;
	});
};

export const getUser = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `/users/me`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setUser(response.data));

		return response;
	});
};

export const validateMobile = (values, setErrors) => async () => {
	const { mobile } = values;
	const newVal = {
		mobile,
	};
	const CREDENTIALS = {
		url: `/sales-men/validate-mobile`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	// return {
	// 	pin: true,
	// 	otp: false,
	// };

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);

		return response;
	});
};

export const setLoginPin = (values, setErrors) => async () => {
	console.log(values);
	const { mobile, pin } = values;
	const newVal = {
		mobile,
		pin: String(pin),
		reset: false,
	};
	const CREDENTIALS = {
		url: `/sales-men/set-pin`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);
		console.log(response);

		return response;
	});
};

const URL = process.env.REACT_APP_API_URL_V5;

console.log(URL);

export const LoginSales = (values, setErrors) => async (dispatch) => {
	const { mobile, pin } = values;
	const newVal = {
		mobile,
		pin: pin?.toString(),
	};
	const CREDENTIALS = {
		url: `/sales-men/login`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setUser(response.data));
		setLocalData(response.data);
		console.log(response);

		return response;
	});
};

export const validateOTP = (values, setErrors) => async () => {
	console.log(values);
	const { mobile, otp } = values;

	console.log(otp);

	const newVal = {
		mobile,
		otp: String(otp),
	};
	const CREDENTIALS = {
		url: `/sales-men/validate-otp`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);
		console.log(response);
		console.log(response);

		return response;
	});
};

export const resendOtp = (values) => {
	console.log(values);
	const { phone } = values;

	const newVal = {
		mobile: phone,
	};
	const CREDENTIALS = {
		url: `/sales-men/resend-otp`,
		method: 'post',
		data: newVal,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(CREDENTIALS);
		toaster.success('OTP resent to you');

		console.log(response);

		return response;
	});
};
export const resetSalesManPin = (values) => async () => {
	console.log(values);

	const newVal = {
		mobile: values?.phone,
	};
	const CREDENTIALS = {
		url: `/sales-men/reset-pin`,
		method: 'post',
		data: newVal,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);
		toaster.success('OTP sent to you');

		return response;
	});
};

export const salesManLogin = (values, setErrors) => async (dispatch) => {
	const { otp = '', mobile } = values;
	const newVal = {
		mobile,
		otp: jsSha512(otp?.toString()),
	};
	const CREDENTIALS = {
		url: `sales-men/login`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setUser(response.data));
		setLocalData(response.data);

		return response;
	});
};

export const additionalResourcesLogin = (values, setErrors) => async (dispatch) => {
	const { password, email } = values;
	const newVal = {
		email,
		// password: jsSha512(password),
		password,
	};

	const CREDENTIALS = {
		url: `/additional-resources/login`,
		method: 'post',
		data: newVal,
		setErrors,
	};

	/* eslint-disable sonarjs/no-identical-functions */
	return API.common(CREDENTIALS).then((response) => {
		dispatch(setUser(response.data));
		setLocalData(response.data);

		return response;
	});
};

export const userLogout = () => async (dispatch) => {
	dispatch(setUser({}));
	redirectToLogin();
};

export const updateUser =
	(values, setErrors, isNotProfileUpdate = false) =>
	async (dispatch) => {
		const url = isNotProfileUpdate ? `/users/${values?.id}` : 'users/me';
		const { password, ...rest } = values;
		let newVal;

		if (password) {
			newVal = {
				password: jsSha512(password),
				...rest,
			};
		} else {
			newVal = {
				...rest,
			};
		}

		const CREDENTIALS = {
			url,
			method: 'put',
			data: newVal,
			setErrors,
		};

		return API.common(CREDENTIALS).then((response) => {
			dispatch(setUser(response.data));
			const text = isNotProfileUpdate ? `'User updated` : 'Profile updated';

			toaster.success(text);

			return response;
		});
	};

export default userSlice.reducer;
